import React from "react";
import { Input, FormFeedback } from "reactstrap";

const TextInput = ({
  input,
  name,
  type,
  placeholder,
  size,
  autoFocus,
  disabled,
  meta: { touched, error }
}) => (
  <div>
    <Input
      {...input}
      disabled={disabled}
      placeholder={placeholder}
      type={type}
      bsSize={size}
      autoFocus={autoFocus}
      valid={touched && error ? false : undefined}
    />
    {touched && error && <FormFeedback>{error}</FormFeedback>}
  </div>
);

export default TextInput;



// WEBPACK FOOTER //
// ./src/system/fields/TextInput/index.jsx